<script lang="ts">
  import Minus from '@lucide/svelte/icons/minus';
  import Plus from '@lucide/svelte/icons/plus';
  import Users from '@lucide/svelte/icons/users';
  import { Button } from '$lib/components/ui/button';
  import { cn } from '$lib/utils';

  type Props = {
    value: number;
    onValueChange: (v: number) => void;
    min?: number;
    max?: number;
    label: string;
    decreaseLabel?: string;
    increaseLabel?: string;
  };

  let {
    value,
    onValueChange,
    min = 1,
    max = 10,
    label,
    decreaseLabel = 'Diminuer',
    increaseLabel = 'Augmenter',
  }: Props = $props();

  function dec() {
    if (value > min) onValueChange(value - 1);
  }
  function inc() {
    if (value < max) onValueChange(value + 1);
  }
</script>

<div
  class={cn(
    'qs-guests flex min-h-[42px] w-full min-w-[130px] flex-row items-center gap-2 rounded-md border border-input bg-background px-2.5 py-1.5 text-left text-sm',
  )}
>
  <span class="qs-guests-label shrink-0 text-[11px] font-medium text-primary">{label}</span>
  <span class="qs-guests-value flex items-center gap-1.5 font-medium">
    <Users class="qs-guests-icon h-3.5 w-3.5 text-primary" />
    <span class="qs-guests-count">{value}</span>
  </span>
  <span class="qs-guests-controls ml-auto flex items-center gap-0.5">
    <Button
      variant="outline"
      size="icon"
      class="qs-guests-decrease h-6 w-6"
      disabled={value <= min}
      aria-label={decreaseLabel}
      onclick={dec}
    >
      <Minus class="h-3 w-3" />
    </Button>
    <Button
      variant="outline"
      size="icon"
      class="qs-guests-increase h-6 w-6"
      disabled={value >= max}
      aria-label={increaseLabel}
      onclick={inc}
    >
      <Plus class="h-3 w-3" />
    </Button>
  </span>
</div>
